import axios from 'axios'
import store from '../store'

let configApi = require('../../config.json')[process.env.NODE_ENV]
const API_URL = configApi.VUE_APP_API;

let config = {
  headers: {  
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers':'X-Requested-With',
    'Content-Type':'application/json'
  }
};

let router = "commerce";

export class Commerces {
  constructor() {
    axios.defaults.headers.common['x-access-token'] = store.state.authData.token
  }

  /**
   * GET all commerces
   * @param {object} params filters, limit, page size
   */
  
   postAccountCommerce(rid, data){
    let url = `${API_URL}/${router}/${rid}/account`;

      return axios.post(url, data)
        .then(response => response.data)
        .catch((error) => {
          return error.response.data
        })
   }

   PutRateCommerce(data) {
    let url = `${API_URL}/commerce-rate`

    return axios.put(url, data)
      .then(response => response.data)
      .catch((error) => {
        return error.response.data
      })
  }

   DeleteRateCommerce(data) {
    let url = `${API_URL}/commerce-rate`;

    return axios.delete(url, {data:data })
          .then(response => response.data)
          .catch((error) => {
            return error.response.data
          })
  }

   postRateCommerce(data){//Insertar tarifas en comercios
    let url = `${API_URL}/commerce-rate`;

      return axios.post(url, data)
        .then(response => response.data)
        .catch((error) => {
          return error.response.data
        })
   }

   getRatesCommerce(rid){
    let url = `${API_URL}/commerce-rate?commerce=${rid}`;

    return axios.get(url, config)
      .then(response => response.data)
      .catch((error) => {
        return error.response.data
      })
   }



   postPointsaleCommerce(rid, data){
    let url = `${API_URL}/${router}/${rid}/pointsale`;

      return axios.post(url, data)
        .then(response => response.data)
        .catch((error) => {
          return error.response.data
        })
   }

   postContactCommerce(rid, data){
    let url = `${API_URL}/${router}/${rid}/contact`;

      return axios.post(url, data)
        .then(response => response.data)
        .catch((error) => {
          return error.response.data
        })
   }

   //commerce/rid/account
  GetCommerces(id) {
    let url = id != undefined ? `${API_URL}/${router}/${id}` : `${API_URL}/${router}`;
    return axios.get(url, config)
      .then(response => response.data)
      .catch((error) => {
        return error.response.data
      })
  }
  async GetCommerceContacts(rid){
    const url =`${API_URL}/${router}/${rid}/contact`;
    return await axios.get(url, config)
      .then(response => response.data)
      .catch((error) => {
        return error.response.data
      })
  }

  //commerce/rid/account
  GetCommercesPointSale(id) {
    let url =  `${API_URL}/${router}/${id}`;
   
    return axios.get(url, config)
      .then(response => response.data)
      .catch((error) => {
        return error.response.data
      })
  }

  //commerce/ by user
  GetUserCommerces(filter) {
    let url =  `${API_URL}/${router}`;

    return axios.get(url,  { params: filter })
      .then(response => response.data)
      .catch((error) => {
        return error.response.data
      })
  }

  /**
   * get Commerce by rid
   * @param {string} rid
   */
  GetCommerce( param = '' ) {
    let url_ = param == '' ? 'commerce': `commerce/${param}`;
    let url = `${API_URL}/${url_}`;
    
    return axios.get(url)
      .then(response => response.data)
      .catch((error) => {
        //console.log(error.response)
        error.response.data.error = error.response.data.message
        return error.response.data
      })
  }

  /**
   * put Commerce by rid update
   * @param {string} rid
   */
  PutCommerce(rid, data) {
    let url = `${API_URL}/${router}/${rid}`

    return axios.put(url, data)
      .then(response => response.data)
      .catch((error) => {
        return error.response.data
      })
  }

  /**
   * post Commerce create
   * @param {string} rid
   */
  PostCommerce(data) {
    let url = `${API_URL}/${router}`

    return axios.post(url, data)
      .then(response => response.data)
      .catch((error) => {
        return error.response.data
      })
  }

  /**
   * delete Commerce remove
   * @param {string} rid
   */
  DeleteCommerce(rid) {
    let url = `${API_URL}/${router}/${rid}`

    return axios.delete(url)
      .then(response => response.data)
      .catch((error) => {
        return error.response.data
      })
  }

}